import _ from 'lodash';

import { ILevelGeneralData } from 'src/app/infrastructure/models/level-general-data';
import { IPageForm } from './page-form';
import { IPageDto, pageDto } from 'src/assets/common/models/page-dto.g';
import { activityData, ActivityData, IActivityData } from '../../activity/models/activity-data';

export interface IPageCache {
    data: IPageData;
    url: string;
}

export const pageData = {
    guid: 'guid',
    nr: 'nr',
    name: 'name',
    normalizedName: 'normalizedName',
    displayName: 'displayName',
    isTab: 'isTab',
    deleted: 'deleted',
    inactive: 'inactive',

    activitiesData: 'activitiesData',
} as const;

export type TPageData = (typeof pageData)[keyof typeof pageData];

export interface IPageData extends ILevelGeneralData
{
    [pageData.guid]: string;
    [pageData.nr]: number | null;
    [pageData.name]: string | null;
    [pageData.normalizedName]: string | null;
    [pageData.displayName]: string | null;
    [pageData.isTab]: boolean;
    [pageData.deleted]: boolean;
    [pageData.inactive]: boolean;

    [pageData.activitiesData]: ActivityData[] | null;
}

export class PageData
    implements IPageData, ILevelGeneralData
{
    [pageData.guid]!: string;
    [pageData.nr]: number | null = null;
    [pageData.name]: string | null = null;
    [pageData.normalizedName]: string | null = null;
    [pageData.displayName]: string | null = null;
    [pageData.isTab]!: boolean;
    [pageData.deleted]!: boolean;
    [pageData.inactive]!: boolean;

    [pageData.activitiesData]: ActivityData[] | null = null;

    protected constructor(modelDto?: IPageDto | null);
    protected constructor(modelData: IPageData, modelForm: IPageForm);
    protected constructor(value?: IPageDto | IPageData | null, modelForm?: IPageForm) {
        if (!!modelForm) {
            const _modelData = value as IPageData;
            _.assign(this, _modelData, modelForm);
        } else if (!!value) {
            const _modelDto = value as IPageDto;
            this[pageData.guid] = _modelDto[pageDto.guid]!;
            this[pageData.nr] = _modelDto[pageDto.nr];
            this[pageData.name] = _modelDto[pageDto.name];
            this[pageData.displayName] = _modelDto[pageDto.displayName];
            this[pageData.isTab] = _modelDto[pageDto.isTab]!;
            this[pageData.deleted] = _modelDto[pageDto.deleted]!;
            this[pageData.inactive] = _modelDto[pageDto.inactive]!;

            this[pageData.activitiesData] = _modelDto[pageDto.activitiesDto]
                ?.map(item => ActivityData.create(item))
                .filter((a): a is IActivityData => a !== null && a[activityData.deleted] === false)
                .sort((a, b) => (a[activityData.name] ?? '').localeCompare(b[activityData.name] ?? ''))
                ?? null;
        }
    }
        
    static create(modelDto?: IPageDto | null): IPageData | null
    static create(modelData: IPageData, modelForm: IPageForm): IPageData | null
    static create(value?: IPageDto | IPageData | null, modelForm?: IPageForm): IPageData | null {

        if (!!modelForm) {
            const _modelData = value as IPageData;
            return new PageData(_modelData, modelForm);
        } else {
            const _modelDto = value as IPageDto | null;
            return _modelDto ? new PageData(_modelDto) : null;
        }
    }
}
